export default function getSubscriptionCurrency(state: any): string | null {
  return state.selfcare?.queryParams?.subscriptionCurrency || null;
}
